// Mandanten einer Kanzlei + Kanal-Status (Drill-in aus dem Kanzlei-Detail).

import { useEffect, useState } from "react";

import { Loader } from "@/components/Loader";

import { getFirmMandanten, OperatorApiError, type MandantItem } from "./api";

export function MandantenList({
  firmId,
  onExpired,
}: {
  firmId: string;
  onExpired: () => void;
}) {
  const [items, setItems] = useState<MandantItem[] | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getFirmMandanten(firmId)
      .then(setItems)
      .catch((e: unknown) => {
        if (e instanceof OperatorApiError && e.status === 401) onExpired();
        else setError(e instanceof Error ? e.message : "Fehler beim Laden");
      });
  }, [firmId, onExpired]);

  if (error) return <p className="op-error">{error}</p>;
  if (!items) return <Loader label="Mandanten werden geladen…" />;
  if (items.length === 0)
    return <p className="op-empty">Noch keine Mandanten importiert.</p>;

  return (
    <table className="op-table">
      <thead>
        <tr>
          <th>Kundennr.</th>
          <th>Mandant</th>
          <th>Desktop / App</th>
          <th>Web-Einladungen</th>
        </tr>
      </thead>
      <tbody>
        {items.map((m) => (
          <tr key={m.id}>
            <td className="op-slug">{m.bmd_kundennr}</td>
            <td>
              <strong>{m.name}</strong>
            </td>
            <td>{m.has_device_client ? "✓" : "—"}</td>
            <td>{m.web_invite_count > 0 ? m.web_invite_count : "—"}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}
